import { render } from "./VirPerformanceView.vue?vue&type=template&id=3d69d834&scoped=true"
import script from "./VirPerformanceView.vue?vue&type=script&lang=js"
export * from "./VirPerformanceView.vue?vue&type=script&lang=js"

import "./VirPerformanceView.vue?vue&type=style&index=0&id=3d69d834&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d69d834"]])

export default __exports__